import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['A pile of free drills you still have to sort and sequence', 'No idea which ones actually fit your team’s age', 'You build every practice from scratch, every week', 'Half the kids standing around waiting their turn', 'You keep paying for it in unpaid hours'];
const withIt = ['A full season already planned, practice by practice', 'Scaled for the age in front of you (5-6 to 13+)', 'Open the volume, print today’s sheet, run it', 'Stations so every kid is moving the whole time', 'Ten minutes the night before and you’re ready'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-ice" data-id="element-274" data-mp="295e8h6ac8ts1">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-275" data-mp="2d79aye409d7e">
        <div className="text-center" data-id="element-276" data-mp="30xv99do7jj47">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-277" data-mp="30wtr6p8rxwcz">
            Why this isn&apos;t another drill dump
          </p>
          <h2 id="vs-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-278" data-mp="1tetqyfvsefyi">
            Free drills vs{' '}
            <span className="text-clay-deep" data-id="element-279" data-mp="235ocfi17lbiw">a planned season</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-280" data-mp="1yeg4kqfj1y7u">
            Yes, there are a thousand free drills online. Finding drills was
            never the hard part — turning them into “what do I run on Tuesday”
            is. That’s the part this does for you.
          </p>
        </div>

        {/* "So no / So yes" — the product's own comparison device (Flag Red vs Outfield Green) */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-ice-dark shadow-card" data-id="element-281" data-mp="2h578hcgqwweu">
          <div className="bg-crimson px-3.5 py-4 text-white sm:p-6" data-id="element-282" data-mp="rphl16r52rz3">
            <span className="font-display text-2xl uppercase leading-none sm:text-3xl" data-id="element-283" data-mp="rrua03vbe2ln">
              So no
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-white/80" data-id="element-284" data-mp="2mtpbk8cqkt61">
              YouTube &amp; free PDFs
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-285" data-mp="2rsiqm57o8s8b">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-white/95 sm:text-sm" data-id="element-286" data-mp="2vsau43i7k86t">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-287" data-mp="35qyxpx9g4kqz">
                    <XIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-288" data-mp="3apjxjvksd2ew" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-green px-3.5 py-4 text-white sm:p-6" data-id="element-289" data-mp="3jix07p8njie6">
            <span className="font-display text-2xl uppercase leading-none text-white sm:text-3xl" data-id="element-290" data-mp="3ojay4egjhbyh">
              So yes
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-white/85" data-id="element-291" data-mp="3thvzih7j21oi">
              Baseball Practice Ready
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-292" data-mp="2gj1rj2f1yiy">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-293" data-mp="3tn3mkl1voa7j">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-294" data-mp="3pnuvxp24wsg7">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-295" data-mp="l7jvnsooj3vn" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}